import { persistor } from 'app/store'
import PMBProfilePic from 'components/PMBProfilePic'
import {
  setIsCustomDate,
  setPaginationTag,
} from 'features/private-views/dashboard/dashboardSlice'
import { logout } from 'features/public-views/login/loginSlice'
import useIsMobile from 'hooks/useIsMobile'
import { LogOut, Pocket, Settings } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  UncontrolledDropdown,
} from 'reactstrap'

const UserDropdown = (args) => {
  const { isV3 } = useSelector((s) => s.dashboard)
  const auth = useSelector((s) => s.auth)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  const onClickLogout = async () => {
    await persistor.purge()
    localStorage.removeItem('transferInventoryFilters')
    localStorage.removeItem('defaultWarehouseInventory')
    localStorage.removeItem('lastFetchTime')
    dispatch(setIsCustomDate(false))
    dispatch(setPaginationTag({ selectedContact: undefined }))
    dispatch(logout())
    window.location.replace('/')
  }

  return (
    <Nav className="nav navbar-nav align-items-center ml-auto">
      <UncontrolledDropdown tag="li" className="me-2" direction="down">
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link d-flex align-items-center gap-2"
          data-testid="navbar-user-dropdown-toggle"
          onClick={(e) => e.preventDefault()}
        >
          {args?.profile?.isSuccess && (
            <>
              <PMBProfilePic
                imgSrc={args?.profile?.data?.makerData?.profilepicUrl}
                altText={args?.profile?.data?.makerData?.name}
                name={args?.profile?.data?.makerData?.name}
                avatarSeed={auth?.id}
                width={40}
                height={40}
              />

              {!isMobile && (
                <div className="d-flex flex-column">
                  <span className="fw-600" style={{ fontSize: '0.9rem' }}>
                    {args?.profile?.data?.makerData?.name}
                  </span>
                  <small
                    className="text-secondary"
                    style={{ fontSize: '0.75rem' }}
                  >
                    {auth?.identity}
                  </small>
                  <small
                    className="text-secondary"
                    style={{ fontSize: '0.75rem' }}
                  >
                    {args?.profile?.data?.ownerData?.companyName &&
                      `🏢 ${args?.profile?.data?.ownerData?.companyName}`}
                  </small>
                </div>
              )}
            </>
          )}
        </DropdownToggle>

        <DropdownMenu className="shadow border-0">
          <DropdownItem className="p-3">
            <div className="d-flex gap-2">
              <PMBProfilePic
                imgSrc={args?.profile?.data?.makerData?.profilepicUrl}
                altText={args?.profile?.data?.makerData?.name}
                name={args?.profile?.data?.makerData?.name}
                avatarSeed={auth?.id}
                width={39}
                height={39}
              />

              <div className="d-flex flex-column">
                <span className="fw-600">
                  {args?.profile?.data?.makerData?.name}
                </span>
                <small className="text-secondary">{auth?.identity}</small>
                <small className="text-secondary">
                  {args?.profile?.data?.makerData?.rolesName}
                </small>
                <small
                  className="text-secondary"
                  style={{ fontSize: '0.75rem' }}
                >
                  {args?.profile?.data?.ownerData?.companyName &&
                    `🏢 ${args?.profile?.data?.ownerData?.companyName}`}
                </small>
              </div>
            </div>
          </DropdownItem>
          <hr className="p-0 m-0 text-secondary"></hr>
          <DropdownItem
            tag={Link}
            to="/pengaturan-profile"
            className="py-2"
            data-testid="navbar-user-settings"
          >
            <Settings size={14} className="me-2" />
            <span className="align-middle">Pengaturan</span>
          </DropdownItem>
          <DropdownItem tag={Link} to="/snk" className="pb-2" data-testid="navbar-user-tnc">
            <Pocket size={14} className="me-2" />
            <span className="align-middle">Syarat & Ketentuan</span>
          </DropdownItem>
          <hr className="p-0 m-0 text-secondary"></hr>
          <DropdownItem
            className="pt-2 pointer"
            tag="a"
            data-testid="navbar-user-logout"
            onClick={() => onClickLogout()}
          >
            <LogOut size={14} className="me-2 text-danger" />
            <span className="align-middle text-danger">Keluar</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </Nav>
  )
}

export default UserDropdown
